var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8571 0H3.14286C1.40971 0 0 1.45118 0 3.23529V16.7647C0 18.5488 1.40971 20 3.14286 20H20.8571C22.5903 20 24 18.5488 24 16.7647V3.23529C24 1.45118 22.5903 0 20.8571 0ZM15.9834 11.0288L10.8406 13.97C10.668 14.0682 10.4766 14.1176 10.2857 14.1176C10.0851 14.1176 9.88457 14.0635 9.70629 13.9553C9.35714 13.7435 9.14286 13.3576 9.14286 12.9412V7.05882C9.14286 6.64235 9.35714 6.25647 9.70629 6.04471C10.0549 5.83353 10.4869 5.82765 10.8406 6.03L15.9834 8.97118C16.3463 9.17882 16.5714 9.57235 16.5714 10C16.5714 10.4276 16.3463 10.8212 15.9834 11.0288Z",
    fill: "#FFBB0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.579961d8ad210cc8856f0df2307e74ff.svg";
export { ForwardRef as ReactComponent };